<template>
    <div>
        <!--banner on-->
        <div>
            <!-- arrow="always" -->
            <div class="carousel-wrapper" ref="carouselWrapper" :style="{ height: carouselHeight + 'px' }">
                <el-carousel :height="carouselHeight + 'px'">
                    <el-carousel-item v-for="(item, index) in banner" :key="index">
                        <img :src="item" style="width: 100%;height: 100%;object-fit: fill;" />
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <!--banner off-->

        <div class="is-main">
            <div class="container" v-if="flag">
                <div class="m-work f-mb20" v-if="recommendArticle.length > 0">
                    <a target="_blank" class="u-workt f-db">
                        {{ recommendArticle[recommendArticleIndex].title }}
                    </a>
                    <div class="u-workc row f-clearfix">
                        <div class="u-workl col-md-6">
                            <el-carousel class="u-workl" height="100%" @change="onRecommendArticle">
                                <el-carousel-item :key="index" :label="index + 1"
                                    v-for="(item, index) in recommendArticle">
                                    <img style="width: 100%;height: 100%" :src="item.header" alt=""
                                        @click="handeleNavigate(item)">
                                </el-carousel-item>
                            </el-carousel>
                        </div>

                        <div class="u-workr f-md-ha col-md-6">
                            <div class="u-workrt">
                                <ul class="f-clearfix">
                                    <template v-for="(recommendItem, recommendIndex) in recommendCate">
                                        <li :key="recommendIndex" v-if="recommendIndex < 4"
                                            @click="handleRecommend(recommendIndex)">
                                            <a target="_blank" class="f-db"
                                                :class="recommendIndex == activeIndex ? 'active' : ''">{{
                                                    recommendItem.name }}</a>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                            <div class="u-workroutc">
                                <div class="u-workrc">
                                    <template v-for="(articleItem, articleIndex) in articleList">
                                        <div class="u-workrclist f-clearfix" :key="articleIndex" v-if="articleIndex < 4"
                                            @click="handeleNavigate(articleItem)">
                                            <div class="u-time f-fl">
                                                <p>{{ formDay(articleItem.time) }}</p>
                                                <p>{{ formDate(articleItem.time) }}</p>
                                            </div>
                                            <div class="u-workrc1 f-fl">
                                                <a target="_blank">{{ articleItem.title }}</a>
                                                <p>{{ articleItem.description }}</p>
                                            </div>
                                            <div class="u-more f-fr">
                                                <a target="_blank" class="f-db"></a>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="m-adv f-mb20 visible-lg visible-md c-shine f-pr f-oh">
                    <img src="@/assets/images/20210108090736.EPUgNvaerTyG.png" alt="">
                </div>
                <div class="m-listhome row">
                    <div class="col-md-6 f-mb20" v-for="(normalItem, normalIndex) in normalCate" :key="normalIndex">
                        <div class="u-listhome f-md-ha" style="height: auto;">
                            <div class="u-listhomet f-clearfix f-mb10">
                                <a class="u-listhometl f-db f-fl">{{ normalItem.name }}</a>
                                <a class="u-listhometr f-db f-fr" @click="handleNavigate(normalItem, -1)">MORE+</a>
                            </div>
                            <div class="u-listhomec" v-if="normalItem.listType == 1">
                                <ul>
                                    <li class="f-clearfix" v-for="(articleItem, articleIndex) in normalItem.articleList"
                                        :key="articleIndex" @click="handeleNavigate(articleItem)">
                                        <a :title="articleItem.title" target="_blank" class="f-db f-fl">
                                            {{ articleItem.title }}
                                        </a>
                                        <span class="f-fr">{{ formDate(articleItem.time) }}</span>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>
                                <el-carousel class="card-list-pc" height="280px">
                                    <el-carousel-item v-for="pageIndex in (normalItem.articleList.length / 2)"
                                        :key="pageIndex" :label="pageIndex">
                                        <div class="u-jianshe">
                                            <ul class="f-clearfix">
                                                <template v-for="(articleItem, articleIndex) in normalItem.articleList">
                                                    <li :key="articleIndex"
                                                        v-if="articleIndex < pageIndex * 2 && articleIndex >= (pageIndex - 1) * 2"
                                                        @click="handeleNavigate(articleItem)">
                                                        <a :title="lastNormalCate" target="_blank" class="f-db">
                                                            <div class="u-jiansheimg">
                                                                <img :src="articleItem.header" alt="">
                                                            </div>
                                                            <p>{{ articleItem.title }}</p>
                                                        </a>
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </el-carousel-item>

                                </el-carousel>
                                <div class="u-jianshe card-list-mobile">
                                    <ul class="f-clearfix">
                                        <template v-for="(articleItem, articleIndex) in normalItem.articleList">
                                            <li :key="articleIndex" v-if="articleIndex < 2"
                                                @click="handeleNavigate(articleItem)">
                                                <a :title="lastNormalCate" target="_blank" class="f-db">
                                                    <div class="u-jiansheimg">
                                                        <img :src="articleItem.header" alt="">
                                                    </div>
                                                    <p>{{ articleItem.title }}</p>
                                                </a>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                <!-- <div class="m-listhome row" v-if="!parityFlag">
                    <template v-for="(normalItem, normalIndex) in normalCate">
                        <div class="col-md-6 f-mb20" :key="normalIndex" v-if="normalIndex < normalCate.length - 1">
                            <div class="u-listhome f-md-ha">
                                <div class="u-listhomet f-clearfix f-mb10">
                                    <a class="u-listhometl f-db f-fl">{{ normalItem.name }}</a>
                                    <a class="u-listhometr f-db f-fr" @click="handleNavigate(normalItem, -1)">MORE+</a>
                                </div>
                                <div class="u-listhomec">
                                    <ul>
                                        <li class="f-clearfix"
                                            v-for="(articleItem, articleIndex) in normalItem.articleList"
                                            :key="articleIndex" @click="handeleNavigate(articleItem)">
                                            <a :title="articleItem.title" target="_blank" class="f-db f-fl">
                                                {{ articleItem.title }}
                                            </a>
                                            <span class="f-fr">{{ formDate(articleItem.createTime) }}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </template>
                </div> -->

                <!-- <div class="m-jianshe f-mb20 f-pr f-oh" v-if="!parityFlag">
                    <div class="u-listhomet f-clearfix f-mb10">
                        <a class="u-listhometl f-db f-fl">{{ lastNormalCate.name }}</a>
                        <a class="u-listhometr f-db f-fr" @click="handleNavigate(lastNormalCate, -1)">MORE+</a>
                    </div>
                    <div class="u-jianshe">
                        <ul class="f-clearfix">
                            <template v-for="(articleItem, articleIndex) in lastNormalCate.articleList">
                                <li :key="articleIndex" v-if="articleIndex < 2" @click="handeleNavigate(articleItem)">
                                    <a :title="lastNormalCate" target="_blank" class="f-db">
                                        <div class="u-jiansheimg">
                                            <img :src="articleItem.header" alt="">
                                        </div>
                                        <p>{{ articleItem.title }}</p>
                                    </a>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div> -->

            </div>
        </div>
    </div>
</template>

<script>
import '../assets/js/qrcode.min.js'

import * as api from '@/api/api'

export default {
    name: "index",
    data() {
        return {
            companyInfo: {},
            articleList: [],
            recommendCate: [],
            normalCate: [],
            recommendArticle: [],
            flag: false,
            activeIndex: 0,
            parityFlag: true,   // 默认偶数
            lastNormalCate: {},
            recommendArticleIndex: 0,
            carouselHeight: 0,
        }
    },
    mounted() {
        this.updateCarouselHeight();
        window.addEventListener('resize', this.updateCarouselHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateCarouselHeight);
    },
    created() {

        let meta = document.createElement("meta")
        meta.id = 'index'
        meta.content = 'sbmklsb'


        this.companyInfo = this.$store.state.siteInfo
        api.indexData({ siteId: this.$store.getters.siteId }).then(res => {
            this.recommendArticle = res.recommendArticle || []
            this.normalCate = res.normalCate || []
            if ((this.normalCate.length % 2) !== 0) {
                this.parityFlag = false
                this.lastNormalCate = this.normalCate[this.normalCate.length - 1]
            }

            this.lastNormalCate = this.normalCate[this.normalCate.length - 1]
            this.recommendCate = res.recommendCate || []
            if (this.recommendCate.length === 0) {
                this.articleList = []
            } else {
                this.articleList = this.recommendCate[0].articleList
            }

            this.flag = true
        })
    },
    methods: {
        updateCarouselHeight() {
            const width = this.$refs.carouselWrapper.clientWidth;
            this.carouselHeight = width * 0.15;
        },
        onRecommendArticle(index) {
            this.recommendArticleIndex = index;
        },
        handleRecommend(recommendIndex) {
            this.activeIndex = recommendIndex
            this.articleList = this.recommendCate[recommendIndex].articleList
        },
        handeleNavigate(item) {
            if (item.progress) { // 跳转交易详情
                this.$router.push({
                    path: `/tradeDetail/${item.id}/${item.progress}/`
                })
            } else {
                this.$router.push({
                    // path: `/detail/${item.id}`
                    path: `/detail?id=${item.id}`
                })
            }

        },
        handleNavigate(item, index) {
            console.log('handleNavigatehandleNavigate', index)

            // this.$store.commit('SET_ACTIVEIDDEX', index)
            // this.$store.commit('SET_ACTIVE_SUB_CATE', item)
            this.$store.commit('SET_ACTIVEID', item.pid)
            this.$router.push({
                path: `/channel?pid=${item.pid}&id=${item.id}`,
            })
        }
    },
    computed: {
        formDate() {    // JS 不同时间格式转换(ISO时间&时间戳转北京时间)
            return date => {

                return date.substr(0, 10)
            }
        },
        formDay() {
            return day => {
                let dt = new Date(day)
                dt = dt.getDate()
                return dt < 10 ? '0' + dt : dt;
            }
        },
        banner() {
            return this.$store.getters.siteInfo.banner
        }
    }
}
</script>

<style scoped>


@media screen and (max-width: 730px) {
    .card-list-mobile {
        display: visible !important;
    }

    .card-list-pc {
        display: none;
    }

    .u-jianshe ul li {
        width: 320px;
        margin-right: 10px;
        float: left;
    }

    .u-jianshe ul li img {
        width: 100%;
        height: 213px;
        transition: all 0.6s;
    }

    .u-jiansheimg {
        width: 100%;
        height: 213px;
        overflow: hidden;
    }
}

@media screen and (min-width:731px) {
    .card-list-mobile {
        display: none;
    }

    .card-list-pc {
        display: visible;
    }

    .u-jianshe ul li {
        width: 280px;
        margin-right: 10px;
        float: left;
    }

    .u-jianshe ul li img {
        width: 100%;
        height: 186px;
        transition: all 0.6s;
    }

    .u-jiansheimg {
        width: 100%;
        height: 186px;
        overflow: hidden;
    }

}

.active {
    color: #005B84;
}

.carousel-wrapper {
    width: 100%;
}
</style>
